const HIDE_EPICS_KEY_PREFIX = 'gh.epicShownOnRapidBoard.';

export function getHideEpics(boardId: string | number): boolean {
	return localStorage.getItem(`${HIDE_EPICS_KEY_PREFIX}${boardId}`) === 'false';
}

export function setHideEpics(boardId: string | number, hideEpics: boolean) {
	localStorage.setItem(`${HIDE_EPICS_KEY_PREFIX}${boardId}`, (!hideEpics).toString());
}
